import React from 'react'
import styled from 'styled-components'

const MysteryBoxCardItem = styled.div`
  margin-top: 20px;
  margin-right: 16px;
  background: ${({ theme }) => theme.bsBg36};
  border-radius: 15px;
  box-shadow: 0px 2px 10px rgba(171, 133, 115, 0.3);
  width: 650px;
  height: 300px;
  box-sizing: border-box;
  display: flex;
  cursor: pointer;
  overflow: hidden;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    flex-direction: column;
    width: 100%;
    height: auto;
  `}
`
const ItemLeft = styled.div`
  width: 224px;
  box-sizing: border-box;
  padding-top: 24px;
  padding-left: 18px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 10px; 
  `}
`
const Avatar = styled.img`
  width: 70px;
  height: 70px;
  border-radius: 100%;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 50px;
    height: 50px;
  `}
`
const ItemTitle = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 17px;
  letter-spacing: 0.02em;
  color: ${({ theme }) => theme.bsText28};
  margin-top: 15px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    display: none;
  `}
`

const ItemData = styled.div`
  position: absolute;
  bottom: 20px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    position: relative;
    bottom: 0px;
  `}
`

const ItemNum = styled.div`
  font-style: normal;
  font-weight: bold;
  font-size: 17px;
  letter-spacing: 0.02em;
  color: ${({ theme }) => theme.bsText28};
`
const ItemNumText = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  letter-spacing: 0.02em;
  color: ${({ theme }) => theme.bsText28};
  opacity: 0.8;
`
const ItemRight = styled.img`
  width: 442px;
  height: 300px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    width: 100%;
    height: auto;
  `}
`
export default function MysteryBoxCard({box}: {box: any}) {
  const goMysteryBox = () => {
    window.open(box.urlName)
  }

  return (
    <MysteryBoxCardItem onClick={() => goMysteryBox()}>
      <ItemLeft>
        <Avatar src={box.image}/>
        <ItemTitle>{box.title}</ItemTitle>
        <ItemData>
          <ItemNum>{box.num}</ItemNum>
          <ItemNumText>items</ItemNumText>
        </ItemData>
      </ItemLeft>
      <ItemRight src={box.image}></ItemRight>
    </MysteryBoxCardItem>
  )
}